import {TrackerDataLayer} from './datalayer';
import {CustomBTTracker} from './tracker/biotrust';
import {AffiliateNetworksTracker} from './tracker/affiliate';
import {BingTracker} from './tracker/bing';
import {TikTokTracker} from './tracker/tiktok';
import {BTTrackersManager} from './manager';
import {OutbrainTracker} from './tracker/outbrain';
import {TaboolaTracker} from './tracker/taboola';
import {RockerBoxTracker} from './tracker/rockerbox';
import {IpDataTracker} from './tracker/ipdata';
import {CagePointTracker} from './tracker/cagepoint';
import {AudacyTracker} from './tracker/audacy';

/**
 * Initializes Trackers.
 * @param settings
 * @param init
 * @param env
 * @param dataLayer
 *
 * @Returns Promise
 */
// eslint-disable-next-line no-unused-vars
async function initTrackers({settings, init = {}, env = 'staging', dataLayer = 'trackersJsDataLayer'}) {
  settings.pageTypePaths = settings.pageTypePaths || {
    home: /^\/$/,
    cart: /^\/cart\/?/i,
    checkout: /\/(secure|sandbox)\/checkout\//i,
    upsell: /\/(secure|sandbox)\/oto\//i,
    thankyou: /\/(secure|sandbox)\/thank-you\//i,
  };

  const trackersManager = new BTTrackersManager(
    {
      settings,
      trackers: {
        bing: BingTracker,
        tiktok: TikTokTracker,
        outbrain: OutbrainTracker,
        bt: CustomBTTracker,
        affnetworks: AffiliateNetworksTracker,
        taboola: TaboolaTracker,
        rockerbox: RockerBoxTracker,
        ipData: IpDataTracker,
        cagePoint: CagePointTracker,
        audacy: AudacyTracker,
      },
      pageTypePaths: settings.pageTypePaths,
    },
  );

  const initPromise = trackersManager.init({...init});

  if (typeof settings.pagePath !== 'undefined') {
    trackersManager.page = settings.pagePath;
  }

  window[dataLayer] = new TrackerDataLayer({trackers: trackersManager, initialData: window[dataLayer] || []});

  return initPromise;
}

export {
  BTTrackersManager,
  CustomBTTracker,
  OutbrainTracker,
  BingTracker,
  TikTokTracker,
  AffiliateNetworksTracker,
  TrackerDataLayer,
  initTrackers,
  TaboolaTracker,
  RockerBoxTracker,
  IpDataTracker,
  CagePointTracker,
  AudacyTracker,
};
